import { ApolloLink, Context, FetchResult, NextLink, Observable, Operation } from '@apollo/client';
import { ITokenService } from './TokenService';
import { ISessionService } from './SessionService';

class AuthLink extends ApolloLink {
    #tokenService: ITokenService;
    #sessionService: ISessionService;

    constructor(tokenService: ITokenService, sessionService: ISessionService) {
        super();
        this.#tokenService = tokenService;
        this.#sessionService = sessionService;
    }

    request(operation: Operation, forward: NextLink): Observable<FetchResult> {
        const token = this.#tokenService.getToken();

        if (!token) {
            this.#sessionService.logoff();

            return new Observable((observer) => {
                observer.complete();
            });
        }

        operation.setContext((context: Context) => {
            context.headers = {
                ...context.headers,
                'X-Auth-Token': token,
            };

            return context;
        });

        return forward(operation);
    }
}

export default AuthLink;
